import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { CheckPermission } from "../Permissions/CheckPermissions";
import ScrollImage from "../../assets/images/chevron-up.svg"
import { CircularProgress } from "@material-ui/core";
import { FaPen , FaRegTrashAlt, FaPlus} from "react-icons/fa";
import { highlightFirstMatch } from "../../Utils/Common";


const Settings = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" },
  ];
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [showsScrolBtn,setShowScrolBtn]= useState(false)
  const [loading,setloading]=useState(true)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getSettingData(token);
  }, []);


  useEffect(() => {
    const handleButtonVisibility=()=>{
      window.pageYOffset > 300 ? setShowScrolBtn(true) : setShowScrolBtn(false)
    }
    window.addEventListener("scroll",handleButtonVisibility)
    return(()=>{
      window.addEventListener("scroll",handleButtonVisibility)
    })

  },[]);

  const getSettingData = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=settings&env=production`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setloading(false)
        console.log("here come the verion---->",result)
        const sortedArray = result?.settings.sort((a, b) => {         
          return a.item_version - b.item_version;        
      })
        setData(sortedArray);
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.item_id, token);
          setDelete(false);
          // props?.history.push(`/carousel-banners/estore`)
          // setsuccess_msg(false)
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props.history.go(0);
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"Setting deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=settings/delete&id=${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 200) {
          setSuccesAlert(true);
        } else {
          setErrorAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Settings" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col  md={4}>
                      <Button
                      disabled={!CheckPermission("settings","add")}
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          props?.history?.push("/add-setting",{add:true});
                        }}
                      >
                        <FaPlus size={12} /> Add Setting
                      </Button>
                    </Col>
                    <Col md={8} className="d-flex justify-content-md-end">
                    <div style={{ marginRight: "50px" }}>
                        <input
                          style={{
                            border: "2px solid rgb(238, 238, 238)",
                            width: "290px",
                            height: "35px",
                          }}
                          className="form-control"
                          placeholder="Search By Item Name..."
                          type="text"
                          id="page_input"
                          onChange={(e) => {
                            setSearchQuery((e.target.value).toLowerCase())
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        {/* <Label>Discount Type</Label> */}
                        <label htmlFor="cars">Status</label>

                        <select
                          name="cars"
                          defaultValue={sortOptions[0].value}
                          id="cars"
                          onChange={(e) => {
                            setSortBy(e.target.value);
                          }}
                          style={{ width: 80, height: 30, marginLeft: 10 }}
                          options={sortOptions}
                        >
                          {sortOptions?.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  {loading ? <div role="status" style={{ textAlign: "center" }}>
                        <CircularProgress
                         size={50} value={100} color={"black"}
                        />
                      </div> :<div className="table-responsive mt-3">
                    <table
                      style={{tableLayout:"fixed"}}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr>
                          <th style={{width:"18%"}}> Item Name</th>
                          <th style={{}}>Item Detail</th>
                          <th style={{width:"120px"}}>Version</th>
                          <th style={{width:"120px"}}>Status</th>
                          <th style={{width:"120px"}}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.item_status !== "Y") {
                              return;
                            }
                          }
                          if(searchQuery)
                          {if(!item?.item_name?.toLowerCase().includes(searchQuery)){
                           return
                          }}

                          return (
                            <tr key={index}>
                              <td>{highlightFirstMatch(item?.item_name, searchQuery)}</td>
                              <td>{item?.item_detail}</td>
                              <td>{item?.item_version}</td>
                              <td style={{textAlign:"center"}}>
                                <Button
                                  color={
                                    item.item_status == "Y"
                                      ? "success"
                                      : "danger"
                                  }
                                >
                                  {item.item_status == "Y"
                                    ? "Enabled"
                                    : "Disabled"}
                                </Button>
                              </td>
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                    {CheckPermission("settings","update") && <div
                                      style={{ width: 30, textAlign: "center" }}
                                      className="text-primary"
                                    >
                                      <a
                                        className="font-size-18"
                                        onClick={() => {
                                          props?.history?.push("/add-setting", {
                                            edit: true,
                                            item: item,
                                          });
                                        }}
                                      ><FaPen /></a>
                                    </div>}

                                    {CheckPermission("settings","delete")&&<div style={{ width: 30 }}>
                                      <Link to="#" className="px-3 text-danger">
                                        <i
                                          className="font-size-18"
                                          onClick={() => {
                                            setItemForDelete(item);
                                            setDelete(true);
                                          }}
                                        ><FaRegTrashAlt /></i>
                                      </Link>
                                    </div>}
                                  </div>
                                </Row>
                              </td>
                            </tr>
                          );
                        })}
                {showsScrolBtn && <div
                        id="scrolToTop"
                          onClick={() => {
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                          }}
                          style={{
                            position: "fixed",
                            bottom: "60px", 
                            right: "60px",
                            color: "gray",
                            textAlign: "center",
                            cursor: "pointer",
                            fontSize: "4em",
                            lineHeight: 0,
                            textDecoration:"none",
                          }}
                        >
                          <img src={ScrollImage} alt="" 
                          style={{width: "40px",
                            background: "#34C38F",
                            borderRadius: "50%",
                            padding:"5px"}} />
                        </div>}
                      </tbody>
                    </table>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Settings;
